"use client"

import { useFormStatus } from "react-dom"
import type { ReactNode } from "react"

export function SubmitButton({
  children,
  pending: pendingLabel = "Un instant…",
  className = "bouton",
  name,
  value,
  disabled,
}: {
  children: ReactNode
  pending?: string
  className?: string
  name?: string
  value?: string
  disabled?: boolean
}) {
  const { pending } = useFormStatus()
  return (
    <button type="submit" name={name} value={value} disabled={pending || disabled} aria-busy={pending} className={className}>
      {pending ? pendingLabel : children}
    </button>
  )
}

export function FormError({ state }: { state?: { error?: string; message?: string; ok?: boolean } }) {
  if (!state) return null
  if (state.error)
    return (
      <p role="alert" className="mt-3 rounded-xl bg-rose-pale border border-alerte/40 px-4 py-3 text-[0.95rem]">
        {state.error}
      </p>
    )
  if (state.ok && state.message)
    return (
      <p role="status" className="mt-3 rounded-xl bg-[#eef4d6] border border-vert/50 px-4 py-3 text-[0.95rem]">
        {state.message}
      </p>
    )
  return null
}
